import core from '@gin-betting/core';

import useWithLocation from './useWithLocation';

const {
    utils: { getAppliedFilters },
} = core;

const useAppliedFilters = (): ReturnType<typeof getAppliedFilters> => {
    return useWithLocation(getAppliedFilters);
};

export default useAppliedFilters;
